module.exports = __webpack_public_path__ + "img/sv66.e93567d9.svg";